if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        // #makemoney-SPEED perf fix 2026-06-18: the modal's full-size media is
        // shipped inside an inert <template> (see product-media-modal.liquid) so
        // it is not parsed/laid-out on initial PDP load. Hydrate it the first
        // time the shopper opens zoom, before showActiveMedia() runs its
        // [data-media-id] lookup. Idempotent on subsequent opens.
        this.hydrateMedia();
        super.show(opener);
        this.showActiveMedia();
      }

      hydrateMedia() {
        if (this.dataset.mediaHydrated === 'true') return;
        const container = this.querySelector('[role="document"]');
        const template = container && container.querySelector('template[data-product-media-modal-template]');
        if (container && template) {
          container.appendChild(template.content.cloneNode(true));
          template.remove();
        }
        this.dataset.mediaHydrated = 'true';
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
